
import { DocumentContentEditor } from "./DocumentContentEditor";

interface ProductRoadmapViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function ProductRoadmapView({ content, documentId, onUpdate }: ProductRoadmapViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Product Vision</h2>
        <DocumentContentEditor
          section="Product Vision"
          content={content.productVision}
          documentId={documentId}
          field="productVision"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Strategic Themes</h2>
        <DocumentContentEditor
          section="Strategic Themes"
          content={content.strategicThemes}
          documentId={documentId}
          field="strategicThemes"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Feature Roadmap</h2>
        <DocumentContentEditor
          section="Feature Roadmap"
          content={content.featureRoadmap}
          documentId={documentId}
          field="featureRoadmap"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Release Timeline</h2>
        <DocumentContentEditor
          section="Release Timeline"
          content={content.releaseTimeline}
          documentId={documentId}
          field="releaseTimeline"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Success Metrics</h2>
        <DocumentContentEditor
          section="Success Metrics"
          content={content.successMetrics}
          documentId={documentId}
          field="successMetrics"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Resource Requirements</h2>
        <DocumentContentEditor
          section="Resource Requirements"
          content={content.resourceRequirements}
          documentId={documentId}
          field="resourceRequirements"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
